import axios from 'axios';
import { getToken, removeToken } from '../utils/storage'

const API_URL = process.env.REACT_APP_API_URL; // Replace with your actual API URL

const api = axios.create({
  baseURL: API_URL
});

// Add a request interceptor to include auth token
api.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add a response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Handle unauthorized access (e.g., redirect to login)
      removeToken()
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);
export default api;